// Theme Service for managing background images and themes
class ThemeService {
  constructor() {
    this.currentTheme = 'default'; // Default theme (no background)
    this.themes = {
      default: {
        name: 'Default',
        backgroundImage: null,
        backgroundColor: 'transparent',
        enabled: false
      },
      diwali: {
        name: 'Diwali',
        backgroundImage: '/assets/images/diwali-bg.png',
        enabled: true
      },
      christmas: {
        name: 'Christmas',
        backgroundImage: '/assets/images/christmas-bg.jpg',
        enabled: true
      },
      holi: {
        name: 'Holi',
        backgroundImage: '/assets/images/holi-bg.jpg',
        enabled: true
      },
      newyear: {
        name: 'New Year',
        backgroundImage: '/assets/images/newyear-bg.jpg',
        enabled: true
      },
      // Add your custom theme here
      custom: {
        name: 'Custom Theme',
        backgroundImage: '/assets/images/your-image.jpg',
        backgroundColor: '#your-color',
        enabled: true
      }
    };
  }

  // Get current theme
  getCurrentTheme() {
    return this.themes[this.currentTheme];
  }

  // Set theme
  setTheme(themeName) {
    if (this.themes[themeName]) {
      this.currentTheme = themeName;
      return true;
    }
    return false;
  }

  // Get all available themes
  getAllThemes() {
    return Object.keys(this.themes).map(key => ({
      key,
      ...this.themes[key]
    }));
  }

  // Get enabled themes only
  getEnabledThemes() {
    return this.getAllThemes().filter(theme => theme.enabled);
  }

  // Check if current theme has background
  hasBackground() {
    const theme = this.getCurrentTheme();
    return theme && theme.backgroundImage && theme.enabled;
  }

  // Get background styles for CSS
  getBackgroundStyles() {
    const theme = this.getCurrentTheme();
    
    if (!theme || !theme.enabled || !theme.backgroundImage) {
      return {
        backgroundImage: 'none',
        backgroundColor: 'transparent'
      };
    }

    return {
      backgroundImage: `url('${theme.backgroundImage}')`,
      backgroundColor: theme.backgroundColor || 'transparent'
    };
  }

  // Add new theme dynamically
  addTheme(themeKey, themeData) {
    this.themes[themeKey] = {
      name: themeData.name,
      backgroundImage: themeData.backgroundImage,
      backgroundColor: themeData.backgroundColor,
      enabled: themeData.enabled || true
    };
  }

  // Remove theme
  removeTheme(themeKey) {
    if (themeKey !== 'default' && this.themes[themeKey]) {
      delete this.themes[themeKey];
      if (this.currentTheme === themeKey) {
        this.currentTheme = 'default';
      }
    }
  }

  // Toggle theme on/off
  toggleTheme(themeKey) {
    if (this.themes[themeKey]) {
      this.themes[themeKey].enabled = !this.themes[themeKey].enabled;
    }
  }
}

// Create singleton instance
const themeService = new ThemeService();

export default themeService;
